<template>
  <div />
</template>

<script>
import api from '@/plugins/api'

export default {
  name: 'AddMT5',
  props: ['execute', 'onSuccess','logout'],
  watch: {
    execute: {
      handler(value) {
        if (value) {
          this.addMT5()
        }
      }
    }
  },
  data() {
    return {
      isLogout: this.logout ? this.logout : false
    }
  },
  methods: {
    addMT5() {
      this.$bus.$emit('loading', false)
      api.addMT5().then((res) => {
        this.$bus.$emit('loading', true)
        if (res.data.code == 200) {
          if (this.isLogout) {
            localStorage.clear()
            this.$store.dispatch('setUser', {})
            this.$store.dispatch('setTokenCookie', {})
          }

          this.$emit('onSuccess')
        }
      })
    }
  }
}
</script>
